/**
 * The client's entry point.
 */

import { LicenseManager } from 'ag-grid-enterprise';
import { LicenseManager as LicenseManagerLegacy } from '@ag-grid-enterprise/core';
import Highcharts3d from 'highcharts/highcharts-3d';
import HighchartsExporting from 'highcharts-exporting';
import { StyleRoot } from 'radium';
import React from 'react';
import ReactDOM from 'react-dom';
import ReactHighchart from 'react-highcharts';
import ReactHighmaps from 'react-highcharts/ReactHighmaps';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router/immutable';
import { RouteStateProvider } from './providers/routeStateProvider';
// import { WebsocketProvider } from './providers/websocketProvider';
import { Auth0Provider } from '@auth0/auth0-react'; // for SSO

import { init } from '@actions/global';
import { LOGIN_SUCCESS } from '@actions/user';
import { checkToken } from '@api/user';
import BaseStyles from '@components/Theme/base-styles';
import ThemeProvider from '@components/Theme/ThemeProvider';
import { userServiceSelector } from '@selectors/global';

import { getRoutes } from './routes';
import configureStore from './store/configureStore';
import Dynamsoft from 'dwt';

Dynamsoft.DWT.ProductKey = `f0071DQEAAAmpmCLKjaLaTyIPOoXc5jYyev2PqEMJN2TYoLJ/LSf0LjVoZwfD4qaucvnhVHJgEigDh/KgavyHL45/ucZ24p6jNe4=;f0071DQEAADkgqStBiyxaNGSCPFpZ10Y6KYrFFjzDPd53PMdgW44IkwaBHMcaV96VdR7As1ylfg5mMtn8BQpeuBPPAmpuh121NfA=;f0071DQEAAMWvygSdb2JRtpXllzvAIe3zOvAo7Dv6oHpCruEsx6eQ11E8q+zm6QSrRpMtNBz++R2UhdT4Y0iKu8XhfVoAz7JQNeQ=;f0071DQEAAN+8kJIiIarNbfZiGZkcvPVg+NIRZPx20rbov5sPiAUx2Qk50dQDTpz4I+Hg0KqUCEbfNl/0f0jbdZblaAE+fc+HNeo=;f0068dAAAAJSAJ6Lp76HDb+gF8u7cvvDzp7Egt/1uC4tWGtqAxfmw4vV/pIesOZnOCvUvOH4JmSBTxZguL2WBQZdHbdFZMnA=;f0068dAAAAFrGRgyfrI35VFKvW3fHlwXAEKg8dYCYyfV699ZayZuRSbTYzsPD7ce2rIAxsghDxUhMRUXvm5nA9WhrlxbB7Qc=;f0068dAAAAMqUjB2WNAXDX65fy1r0K2BwDuKvhz/OVl62Ec3Jr7JLNpuBhXaI198qr0iAGnYdL63cKwaCVQGKxhb2+KbG0i4=;f0068dAAAAC7qzSwykYmJzEvOR6HCdc65fsmF9kRQsaEqBJJLbrVdnVcfzj5Dlkli4syJXoPsdLZLsqtnVxcqNfEiy/8aNOI=;f0068dAAAAELAor8zijKaf7GUPsexgOXGoFoJaAGwEAGzGyAYnxzhEJZeFsQ2JHBaNCjljH6gpaNpWIiaX3tzaM57w+Wt/sI=;f0068dAAAAAZ21ztw5C6tPpJpi2CQRidudGbRjnvn2pk6V653TIsGPGKVvLfqx8TaSBpnMYLryD4xSpbUlAITgEIxKSmI7RM=;f0068dAAAABqC7VHIzb6eTzIS83rrur/50gu3vQMPQ4QFpMnHpFCKhlKu6Fc/spUS41ZekkD7HPNQrubiUYB0knrKQrt77nc=;f0068dAAAAGN1OOcESF7cwJ8idOPDkHr8bAk4f4d5kbfOfLhU8HbDs+AXlfZf089o8LBuz+LikA9l2lqk8JRxWVvuxhQyNos=`;
Dynamsoft.DWT.ResourcesPath = '/public/dwt-resources';

LicenseManager.setLicenseKey(
  'Using_this_{AG_Grid}_Enterprise_key_{AG-065225}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{True_Prodigy}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{True_Prodigy}_only_for_{2}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{True_Prodigy}_need_to_be_licensed___{True_Prodigy}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{22_October_2025}____[v3]_[01]_MTc2MTA4NzYwMDAwMA==7626ac365cdb36093fe7991f0bd83e8e',
);
LicenseManagerLegacy.setLicenseKey(
  'Using_this_{AG_Grid}_Enterprise_key_{AG-065225}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{True_Prodigy}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{True_Prodigy}_only_for_{2}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{True_Prodigy}_need_to_be_licensed___{True_Prodigy}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{22_October_2025}____[v3]_[01]_MTc2MTA4NzYwMDAwMA==7626ac365cdb36093fe7991f0bd83e8e',
);

const auth0Config = {
  domain: 'login.trueprodigyapps.com',
  clientId: 'fjRwxg5mSR7QQgIHnxvzbStcd5fPRc3i',
  authorizationParams: {
    audience: 'https://dev-wrmdvblhk07q5tkj.us.auth0.com/api/v2/',

    redirect_uri: `${window.location.origin}/login`,
  },
  cacheLocation: 'localstorage', // auth0 sessions were not registered by useAuth0 hook without this
};

if (typeof Highcharts === 'object') {
  HighchartsExporting(ReactHighchart.Highcharts);
  Highcharts3d(ReactHighchart.Highcharts);
  HighchartsExporting(ReactHighmaps.Highcharts);
}

ReactHighchart.Highcharts.setOptions({
  credits: {
    enabled: false,
  },
});

ReactHighmaps.Highcharts.setOptions({
  credits: {
    enabled: false,
  },
});

// Enable some stuff during development to ease debugging
if (process.env.NODE_ENV !== 'production') {
  // For dev tool support, attach to window...
  window.React = React;
}

async function boot() {
  const { history, store } = configureStore();

  await store.dispatch(init());
  const params = new URLSearchParams(window.location.search);
  const isRemember = params.get('isRemember');

  // Check for session in local storage
  if (localStorage) {
    const session = localStorage.getItem('session');

    if (session && isRemember) {
      const userData = JSON.parse(session);

      try {
        const userService = userServiceSelector(store.getState());
        const response = await checkToken(
          { userService },
          {
            token: userData.user.token,
          },
        );
        if (!response.error) {
          store.dispatch({ data: response, type: LOGIN_SUCCESS });
        }
        if (window.location.pathname.indexOf('reset') === -1) {
          history.push(window.location.pathname);
        }
      } catch (error) {
        console.error('token is invalid'); // eslint-disable-line no-console
      }
    }
  }

  ReactDOM.render(
    <StyleRoot>
      <BaseStyles />
      <Provider store={store}>
        <Auth0Provider {...auth0Config}>
          <ConnectedRouter history={history}>
            <RouteStateProvider>
              <ThemeProvider>
                {/* <WebsocketProvider>{getRoutes(store)}</WebsocketProvider> */}
                {getRoutes(store)}
              </ThemeProvider>
            </RouteStateProvider>
          </ConnectedRouter>
        </Auth0Provider>
      </Provider>
    </StyleRoot>,
    document.getElementById('root'),
  );
}

boot();
